import { render, staticRenderFns } from "./QQ.vue?vue&type=template&id=4d9deb77&scoped=true&"
import script from "./QQ.vue?vue&type=script&lang=js&"
export * from "./QQ.vue?vue&type=script&lang=js&"
import style0 from "./QQ.vue?vue&type=style&index=0&id=4d9deb77&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9deb77",
  null
  
)

export default component.exports